import { AccordionHtmlContent } from "@/components/catalogue/AccordionHtmlContent";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface HistoryAccordionProps {
  historyCalculated: string | null;
  tirageHistoryCalculated: string | null;
  t: (key: string) => string;
  title?: string;
}

export function HistoryAccordion({
  historyCalculated,
  tirageHistoryCalculated,
  t,
  title,
}: HistoryAccordionProps) {
  if (!historyCalculated && !tirageHistoryCalculated) return null;

  return (
    <AccordionItem value="history">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {title ?? t("singleArtworkSubtitleHistory")}
      </AccordionTrigger>
      <AccordionContent>
        {historyCalculated && <AccordionHtmlContent html={historyCalculated} />}
        {tirageHistoryCalculated && (
          <>
            {historyCalculated && <div className="mt-4" />}
            <AccordionHtmlContent html={tirageHistoryCalculated} />
          </>
        )}
      </AccordionContent>
    </AccordionItem>
  );
}
